import { createTheme } from "@mui/material";

export const Theme = createTheme({
  typography: {
    fontFamily: "Montserrat",
  },
  palette: {
    primary: {
      main: "#000000",
    },
    secondary: {
      main: "#D3D3D3",
    },
  },
});
